/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_SubtitleInputs */

const cs_sklik_subtitle = /** @type {(inputs: Sklik_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte účet Sklik pro atribuci leadů, odesílání konverzí, retargetingová publika a statistiky kampaní. Štítky PI3 u nemovitostí stále napájí produktové inzeráty Sreality.`)
};

const en_sklik_subtitle = /** @type {(inputs: Sklik_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your Sklik account to attribute leads, upload conversions, grow retargeting audiences, and pull campaign stats. Listing PI3 labels on properties still feed Sreality product ads.`)
};

/**
* | output |
* | --- |
* | "Connect your Sklik account to attribute leads, upload conversions, grow retargeting audiences, and pull campaign stats. Listing PI3 labels on properties stil..." |
*
* @param {Sklik_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_subtitle = /** @type {((inputs?: Sklik_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_subtitle(inputs)
	return cs_sklik_subtitle(inputs)
});